<template>
  <Teleport to="body">
    <div class="popup">
      <!-- The Modal -->
      <transition name="fade" mode="out-in">
        <div v-if="isPopupShown" class="w3-modal" @click.prevent>
          <div class="w3-modal-content">
            <simplebar data-simplebar-auto-hide="false">
              <div class="container">
                <div>
                  <span class="w3-display-topright close_detail"><i class="sherpa-icon icon-cerrar" @click="popupClose()"></i></span>
                  <div class="w3-container">
                    <div v-if="title" class="w3-row popup-title">
                      {{ title }}
                    </div>
                    <div class="w3-row popup-content">
                      <definition v-if="content"
                        :type="type"
                        :content="content"
                        :id="id"
                        :language="language"
                        :visuals="visuals"
                        :authorization="authorization"
                        :apiparams="apiparams"
                        :showloading="true"
                        :fromPopup="true"
                        :fromPopupId="definitionContentId"
                        @refreshDefinition="refreshDefinition"
                        @popupClose="popupClose"
                      />
                      <span class="txtPopup" v-else>{{ txtContent }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </simplebar>
          </div>
        </div>
      </transition>
    </div>
  </Teleport>
</template>

<script>
import { defineAsyncComponent } from 'vue'
import simplebar from 'simplebar-vue'
import 'simplebar-core/dist/simplebar.css'

export default {
  name: 'popup',
  props: [
    'isPopupShown',
    'title',
    'type',
    'content',
    'txtContent',
    'id',
    'language',
    'authorization',
    'visuals',
    'apiparams',
    'definitionContentId'
  ],
  data () {
    return {
    }
  },
  components: {
    simplebar,
    Definition: defineAsyncComponent(() => import('../definition.vue')) // Webpack's asynchronous import for recursivity components
  },
  methods: {
    popupClose () {
      this.$emit('popupClose')
    },
    refreshDefinition (newRequestObject) {
    }
  }
}
</script>
